export function defineLogger(createConsumerLogger = () => console) {
    return {
        id: 's2:logger',
        create: () => ({
            '1.0.0': (consumerId, consumerName) => ({
                featureService: createConsumerLogger(consumerId, consumerName),
            }),
        }),
    };
}
//# sourceMappingURL=index.js.map